<template>
  <div :class="['slider', `slider-${sliderId}`]">
    <select
      v-model="currentYear"
      v-if="!this.hideDropDown"
      class="slider__year-select"
    >
      <option v-for="item in years" :value="item" :key="`year${item}`">{{ item }}</option>
    </select>
    <swiper
      :modules="modules"
      :slides-per-view="1.2"
      :space-between="24"
      :navigation="swiperOptions.navigation"
      :pagination="{ clickable: true }"
      :breakpoints="swiperOptions.breakpoints"
      :watch-slides-progress="true"
      :key="`swiper${currentYear}`"
      ref="slider"
      :lazy="{loadPrevNext: true, loadPrevNextAmount: 1}"
      @swiper="onSwiper"
      @slideChange="changeActiveIndex"
    >
      <swiper-slide
        v-for="(item, index) in currentMediaArray"
        :key="`image${index}${currentYear}`"
        :aria-hidden="checkSlideVisibility(index)"
      >
        <a href="#" class="slider__image" @click.prevent="showMediaPopup(item, index)" :tabindex="checkSlideVisibility(index) ? '-1' : '0'">
          <img :src="item.preview" alt="" loading="lazy"/>
          <div class="slider__image-veil" v-if="video"></div>
          <img class="slider__image-play" v-if="video" src="../assets/img/icons/play.svg" alt="" />
        </a>
      </swiper-slide>
    </swiper>
    <span :class="['slider__next', `slider-${sliderId}__next`]">
      <img src="../assets/img/icons/next.svg" alt="" />
    </span>
    <span :class="['slider__prev', `slider-${sliderId}__prev`]">
      <img src="../assets/img/icons/prev.svg" alt="" />
    </span>
    <div class="media-popup" v-if="showPopup">
      <div class="media-popup__box" v-click-outside="hideMediaPopup">
        <a href="#" class="media-popup__close" @click.prevent="hideMediaPopup()" aria-label="Закрыть">
          <img src="../assets/img/icons/cross.svg" alt="" />
        </a>
        <template v-if="video">
          <!--video controls class="media-popup__video" :key="`video${currentMediaIndex}`" autoplay>
            <source :src="currentMediaUrl" type="video/mp4">
            Your browser does not support the video tag.
          </video-->
          <iframe
              class="media-popup__video"
              :src="`https://vk.com/video_ext.php?oid=-140851186&id=${currentMediaUrl}&hd=2`"
              width="853" height="480"
              allow="autoplay; encrypted-media; fullscreen; picture-in-picture; screen-wake-lock;"
              frameborder="0"
              allowfullscreen
              :key="`video${currentMediaIndex}`"
          ></iframe>
        </template>
        <template v-else>
          <img
            :src="currentPreviewUrl"
            alt=""
            class="media-popup__image media-popup__image_preview"
            :key="`media${currentMediaIndex}preview`"
            loading="lazy"
          >
          <img
            :src="currentMediaUrl"
            alt=""
            class="media-popup__image"
            :key="`media${currentMediaIndex}`"
            loading="lazy"
            @load="onImgLoad"
          >
          <img v-if="!imageLoaded" src="../assets/img/loader.png" class="media-popup__loader" alt=""/>
        </template>
        <a href="#" :class="['media-popup__prev', {'_disabled': !showPrev}]" @click.prevent="prev()" aria-label="Предыдущий слайд">
          <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M9 17L1 9L9 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
        <a href="" :class="['media-popup__next', {'_disabled': !showNext}]" @click.prevent="next()" aria-label="Следующий слайд">
          <svg width="10" height="18" viewBox="0 0 10 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M1 17L9 9L1 1" stroke="white" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </a>
      </div>
    </div>
  </div>
</template>
<script>
import { Navigation, Pagination, A11y, Lazy } from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/vue';
import VueScreenSizeMixin from 'vue-screen-size';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';

import dataArrayPhoto from  "../assets/data/photo.json"
import dataArrayVideo from  "../assets/data/video.json"

export default {
  name: "MediaSlider",
  mixins: [VueScreenSizeMixin],
  components: {
    Swiper,
    SwiperSlide,
  },
  props: {
    hideDropDown: {
      type: Boolean,
      default: false,
    },
    sliderId: {
      type: String,
      default: '',
    },
    video: {
      type: Boolean,
      default: false
    },
    wrapperId: {
      type: String,
      default: '',
    }
  },
  setup() {
    return {
      modules: [Navigation, Pagination, A11y, Lazy],
    };
  },
  data() {
    return {
      dataArray: this.video ? dataArrayVideo : dataArrayPhoto,
      currentYear: undefined,
      years: undefined,
      currentMediaArray: [],
      swiperOptions: {
        breakpoints: {
          500: {
            slidesPerView: 1.5
          },
          768: {
            slidesPerView: 1.8
          },
          900: {
            slidesPerView: 2.4
          },
          1024: {
            slidesPerView: 3
          },
        },
        navigation: {
          nextEl: `.slider-${this.sliderId}__next`,
          prevEl: `.slider-${this.sliderId}__prev`,
          disabledClass: '_disabled'
        },
      },
      showPopup: false,
      currentPreviewUrl: '',
      currentMediaUrl: '',
      currentMediaIndex: 0,
      swiper: null,
      showNext: true,
      showPrev: true,
      imageLoaded: false,
      activeSlideIndex: 0
    }
  },
  watch: {
    currentYear() {
      let filteredByYear = this.dataArray.filter(obj => {
        return obj.year === this.currentYear;
      })
      this.currentMediaArray = filteredByYear[0].media;
      this.showPrev = true;
      this.showNext = true;
    },
  },
  mounted() {
    this.years = this.dataArray.map(obj => {
      return obj.year;
    })
    this.currentYear = this.years[0];
  },
  methods: {
    showMediaPopup(item, index) {
      this.showPopup = true;
      this.currentPreviewUrl = item.preview;
      this.currentMediaUrl = item.media;
      this.currentMediaIndex = index;
      document.getElementById(this.wrapperId).style.zIndex = '2';
      if (this.currentMediaIndex === 0) {
        this.showPrev = false;
      }
      if (this.currentMediaArray[this.currentMediaIndex+1] === undefined) {
        this.showNext = false;
      }
      document.body.style.overflow = 'hidden';
    },
    hideMediaPopup() {
      this.showPopup = false;
      document.getElementById(this.wrapperId).style.zIndex = null;
      this.showPrev = true;
      this.showNext = true;
      document.body.style.overflow = '';
    },
    onSwiper(swiper) {
      this.swiper = swiper;
    },
    changeCurrentMedia() {
      this.imageLoaded = false;
      this.currentPreviewUrl = this.currentMediaArray[this.currentMediaIndex].preview;
      this.currentMediaUrl = this.currentMediaArray[this.currentMediaIndex].media;
      this.swiper.slideTo(this.currentMediaIndex);
    },
    next() {
      this.currentMediaIndex++;
      this.showPrev = true;
      this.changeCurrentMedia();
      if (this.currentMediaArray[this.currentMediaIndex+1] === undefined) {
        this.showNext = false;
      }
    },
    prev() {
      this.currentMediaIndex--;
      this.showNext = true;
      this.changeCurrentMedia();
      if (this.currentMediaIndex === 0) {
        this.showPrev = false;
      }
    },
    onImgLoad() {
      this.imageLoaded = true;
    },
    changeActiveIndex () {
      this.activeSlideIndex = this.$refs.slider.$el.swiper.activeIndex;
    },
    checkSlideVisibility(index) {
      if (this.$vssWidth > 1023) {
        return index > this.activeSlideIndex + 2 || index < this.activeSlideIndex;
      } else if (this.$vssWidth <= 1023 && this.$vssWidth > 767) {
        return index > this.activeSlideIndex + 1 || index < this.activeSlideIndex;
      } else {
        return index > this.activeSlideIndex || index < this.activeSlideIndex;
      }
    }
  }
};
</script>
